import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import Results from './Results';
import QR from './QRCode';
import { fetchPollStateFb, listenForScores } from '../db';

interface IMatchParams {
  pollId: string;
}

interface IPollViewerProps extends RouteComponentProps {
  poll: any;
  fetchPolls: () => void;
  listen: (pollId: string) => void;
  match: {
    isExact: any;
    path: any;
    url: any;
    params: IMatchParams;
  };
  dispatch: ThunkDispatch<any, any, any>;
}

const PollViewer: React.SFC<IPollViewerProps> = props => {
  const { pollId } = props.match.params;
  const { fetchPolls, listen, poll } = props;
  const { scores } = poll;

  useEffect(() => {
    fetchPolls();
    listen(pollId);
  }, [fetchPolls, listen, pollId]);

  return (
    <>
      {!scores && <QR pollId={pollId} {...props} />}
      {scores && <Results {...props} />}
    </>
  );
};

const mapStateToProps = (state: any, ownProps: IPollViewerProps) => {
  const { pollId } = ownProps.match.params;
  const polls = { ...state.polls };
  const thisPoll = polls[pollId] || { scores: undefined };
  return { poll: thisPoll };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchPolls: () => dispatch(fetchPollStateFb),
    listen: (pollId: string) => dispatch(listenForScores(pollId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PollViewer);
